import type { Feature } from "../../types";
import { LinkButton } from "../ui/Button";
import { StarMark } from "../ui/StarMark";
import "./FeatureSection.css";
import { assetUrl } from "../../wordpress";

type FeatureSectionProps = {
	feature: Feature;
};

/**
 * Bloco de apresentação: painel de texto e fotografia com o mesmo peso — duas
 * colunas iguais, esticadas à mesma altura. Com `reversed`, a fotografia passa
 * para a esquerda, para as secções seguidas alternarem de lado.
 */
export function FeatureSection({ feature }: FeatureSectionProps) {
	const headingId = `${feature.id}-lead`;

	return (
		<section
			className={feature.reversed ? "feature feature--reversed" : "feature"}
			id={feature.id}
			aria-labelledby={headingId}
		>
			<div className="feature__grid">
				<div className="feature__panel">
					<p className="feature__kicker">
						<StarMark className="feature__star" />
						{feature.kicker}
					</p>

					<p className="feature__lead" id={headingId}>
						{feature.lead}
					</p>

					{feature.paragraphs.map((paragraph) => (
						<p className="feature__body" key={paragraph.slice(0, 24)}>
							{paragraph}
						</p>
					))}

					<LinkButton
						className="feature__cta"
						href={feature.cta.href}
						variant="outline"
					>
						{feature.cta.label}
					</LinkButton>
				</div>

				<figure className="feature__figure">
					<img src={assetUrl(feature.photo.src)} alt={feature.photo.alt} loading="lazy" />
					{feature.photo.credit ? (
						<figcaption>{feature.photo.credit}</figcaption>
					) : null}
				</figure>
			</div>
		</section>
	);
}
